import { client } from './client'

const trackingService = async (userId: string, cocap: string, scope: 'personal' | 'team') => {
  const { data } = await client.get(`/tracking/${scope}/${userId}`, {
    headers: {
      cocap
    }
  })
  return data
}

const getAllSavers = async (cocap: string) => {
  const { data } = await client.get('/person/savers', {
    headers: {
      cocap
    }
  })
  return data
}

export { trackingService, getAllSavers }
